<template>
    <div>
        <div class="flex items-stretch gap-3 text-left">
            <img :src="InsightGradientBar" alt="" class="w-2.25 rounded-full object-cover" aria-hidden="true" />
            <div class="flex flex-col gap-2">
                <span class="nadia-chat-bold">{{ insightTitle || firstSentence }}</span>
                <MarkdownText class="text-valence-grey-750 nadia-chat" :text="insightTitle ? (insight ?? '') : restOfInsight" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
/**
 * Serves double duty for displaying two similar widgets, the values insight widget and the internal thinking widget.
 * Both allow saving the insight to a conversation topic for later.
 *
 * This component will eventually be removed, it is based off ChatInsightAccordion.
 */
import InsightGradientBar from "~img/insight-gradient-bar.png";
import MarkdownText from "~vue/MarkdownText.vue";
import type { ParseActionsInternalThinkingAction, ParseActionsValuesInsightAction } from "~vue/types/chat";
import { computed } from "vue";

type ChatInsightAccordionProps = {
    data: ParseActionsInternalThinkingAction | ParseActionsValuesInsightAction;
};

const { data } = defineProps<ChatInsightAccordionProps>();

const insightTitle = computed(() => {
    return data.action_params.short_title;
});

const insight = computed(() => data.action_params.final_response);

const firstSentence = computed(() => {
    if (!insight.value) {
        return "";
    }
    return insight.value.split(". ")[0] + ".";
});

const restOfInsight = computed(() => {
    if (!insight.value) {
        return "";
    }
    return insight.value.split(". ").slice(1).join(". ");
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";
.insight-accordion:deep() {
    .item {
        @apply shadow-none!;
    }
}
</style>
